import * as angular from 'angular';

export interface StorageFcfsConfirmationResource
    extends ng.resource.IResourceClass<
        ng.resource.IResource<StorageFcfsConfirmationDto>
    > {
    uploadConfirmation: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageFcfsConfirmationDto>
    >;
    simulateSsoResponse: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
}

function storageFcfsConfirmationResource(
    $resource: ng.resource.IResourceService,
    API_URL
): StorageFcfsConfirmationResource {
    return <StorageFcfsConfirmationResource>$resource(
        API_URL.STORAGE_FCFS_CONFIRMATION,
        {},
        {
            uploadConfirmation: {
                method: 'POST',
                url: API_URL.STORAGE_FCFS_CONFIRMATION
            },
            get: {
                method: 'GET',
                url: API_URL.STORAGE_FCFS_CONFIRMATION + '/:id/acceptance',
                transformResponse: function (data, headers, status) {
                    return { data: data, headers: headers, status: status };
                }
            }
        }
    );
}

angular
    .module('app')
    .factory(
        'storageFcfsConfirmationResource',
        storageFcfsConfirmationResource
    );
